import React from 'react';

import { WithStyles, withStyles } from '@material-ui/core';
import { get } from 'lodash';

import { PatientFormQuestion } from '@lib/resources/types';
import storageService from '@lib/services/storageService';

import styles from './InsuranceCard.styles';

interface InsuranceCardProps extends WithStyles<typeof styles> {
  question: PatientFormQuestion;
}

function InsuranceCard({ question, classes }: InsuranceCardProps) {
  const token = storageService.getToken();
  const answers = get(question, 'answers', []);
  const frontImageUrl = `${get(answers, '[0].text.url', '')}?token=${token}`;
  const backImageUrl = `${get(answers, '[0].text.urlBack', '')}?token=${token}`;

  return (
    <div className={classes.root}>
      <img src={frontImageUrl} alt="Front of insurance card" />
      <img src={backImageUrl} alt="Back of insurance card" />
    </div>
  );
}

export default withStyles(styles)(InsuranceCard);
